import React, { useImperativeHandle, forwardRef, useEffect } from 'react';
import { View } from 'react-native';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useTheme } from '@hmsexp/component-library';
import { highChartPieStyling } from '../style';
import Exporting from 'highcharts/modules/exporting';
import OfflineExporting from 'highcharts/modules/offline-exporting';
import exportData from 'highcharts/modules/export-data';
import exporting from 'highcharts/modules/exporting';
import highchartsMore from 'highcharts/highcharts-more';
import solidGauge from 'highcharts/modules/solid-gauge';
import { useFormatPieChartData } from '../customHooks/useFormatPieChartData';
import HighchartsAnnotations from 'highcharts/modules/annotations';

if (typeof HighchartsAnnotations === 'function') HighchartsAnnotations(Highcharts);
else if (typeof HighchartsAnnotations?.default === 'function') HighchartsAnnotations.default(Highcharts);

if (typeof highchartsMore === 'function') highchartsMore(Highcharts);
else if (typeof highchartsMore?.default === 'function') highchartsMore.default(Highcharts);

if (typeof solidGauge === 'function') solidGauge(Highcharts);
else if (typeof solidGauge?.default === 'function') solidGauge.default(Highcharts);

if (typeof exporting === 'function') exporting(Highcharts);
else if (typeof exporting?.default === 'function') exporting.default(Highcharts);

if (typeof exportData === 'function') exportData(Highcharts);
else if (typeof exportData?.default === 'function') exportData.default(Highcharts);

if (typeof Exporting === 'function') Exporting(Highcharts);
else if (typeof Exporting?.default === 'function') Exporting.default(Highcharts);

if (typeof OfflineExporting === 'function') OfflineExporting(Highcharts);
else if (typeof OfflineExporting?.default === 'function') OfflineExporting.default(Highcharts);

const HighChartPie = forwardRef((props, ref) => {
  const { options, value = 0, tooltipComponent, style = {}, onChartClick, isLowSampleSize, defaultOption, ...rest } = props;
  const theme = useTheme();
  const styles = highChartPieStyling(theme);
  const chartComponentRef = React.useRef();

  const { formattedChartOption } = useFormatPieChartData(options, defaultOption, value, tooltipComponent, isLowSampleSize, chartComponentRef);

  useImperativeHandle(ref, () => ({
    chart: chartComponentRef.current?.chart
  }));

  useEffect(() => {
    const chart = chartComponentRef.current.chart;
    const handleClick = event => {
      onChartClick && onChartClick(event.chartX, event.chartY);
    };
    if (chart) {
      chart.container.addEventListener('click', handleClick);
    }
    return () => {
      if (chart) {
        chart.container.removeEventListener('click', handleClick);
      }
    };
  }, []);

  return (
    <View style={[styles.container, style.container]}>
      <HighchartsReact ref={chartComponentRef} highcharts={Highcharts} options={formattedChartOption} {...rest} />
    </View>
  );
});

export default HighChartPie;
